/**
 * Sets the document title and keeps the canonical link tag in sync with the current URL.
 * Creates the <link rel="canonical"> tag if it doesn't already exist in <head>.
 */
export const setPageTitle = (title: string): void => {
	document.title = title;

	let canonicalLink = document.querySelector<HTMLLinkElement>("link[rel='canonical']");
	if (!canonicalLink) {
		canonicalLink = document.createElement('link');
		canonicalLink.setAttribute('rel', 'canonical');

		const viewportMeta = document.querySelector("meta[name='viewport']");
		if (viewportMeta?.nextSibling) {
			viewportMeta.parentNode?.insertBefore(canonicalLink, viewportMeta.nextSibling);
		} else if (viewportMeta) {
			viewportMeta.parentNode?.appendChild(canonicalLink);
		} else {
			document.head.appendChild(canonicalLink);
		}
	}
	canonicalLink.setAttribute('href', window.location.href.split('?')[0].split('#')[0]);
};
